import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import store from './store'
import VueGtag from 'vue-gtag'
import VueCookies from 'vue-cookies'
import extendeds from './utils/extend-string.js'
import getGoogleAnalyticsSettings from './utils/googleAnalytics'
import { applyStoneRebrandFavicon } from './utils/stone-rebrand-favicon.utils'
import { toStoneBrand } from './utils/stone-rebrand.utils'

import 'emerald-workbench/dist/emerald.pagarme.min.css'

import './plugins/click-outside'

Vue.config.productionTip = false

applyStoneRebrandFavicon()
document.title = toStoneBrand(document.title)

if (['production'].includes(process.env.NODE_ENV)) {
  const googleAnalyticsSettings = getGoogleAnalyticsSettings()
  Vue.use(VueGtag, googleAnalyticsSettings, router)
}

Vue.use(VueCookies)
new Vue({
  router,
  extendeds,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
